import React, { useMemo, useState } from 'react';
import { useWarehouses } from '@features/warehouses/hooks/useWarehouseOperations';
import { useTutorialStore } from '../../../../application/store/TutorialStore';
import WarehouseOnboardingCreateStep from './WarehouseOnboardingCreateStep';
import WarehouseOnboardingInfoStep from './WarehouseOnboardingInfoStep';
import WarehouseOnboardingListStep from './WarehouseOnboardingListStep';
import { getPresentInfoCategories } from './warehouseOnboarding.utils';

type OverlayPhase = 'setup' | 'info';

interface InventoryOnboardingStepProps {
  onDismiss: () => void;
}

const InventoryOnboardingStep: React.FC<InventoryOnboardingStepProps> = ({ onDismiss }) => {
  const { warehouses } = useWarehouses();
  const { markStepCompleted, setCurrentStep } = useTutorialStore();
  const [phase, setPhase] = useState<OverlayPhase>('setup');

  const hasWarehouses = (warehouses?.length ?? 0) > 0;
  const infoCategories = useMemo(
    () => getPresentInfoCategories(warehouses ?? []),
    [warehouses],
  );

  const finishOnboarding = () => {
    markStepCompleted('inventory');
    setCurrentStep(3);
    onDismiss();
  };

  if (phase === 'info' && infoCategories.length > 0) {
    return (
      <WarehouseOnboardingInfoStep
        categories={infoCategories}
        onFinish={finishOnboarding}
      />
    );
  }

  if (hasWarehouses) {
    return (
      <WarehouseOnboardingListStep
        warehouses={warehouses ?? []}
        onDone={() => setPhase('info')}
      />
    );
  }

  return <WarehouseOnboardingCreateStep onDismiss={onDismiss} />;
};

export default InventoryOnboardingStep;
